import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle, XCircle } from "lucide-react";

interface OrderDetailsErrorProps {
  error: Error | string | null;
  noId?: boolean;
}

export function OrderDetailsError({ error, noId = false }: OrderDetailsErrorProps) {
  return (
    <div className="hidden lg:flex flex-col w-[420px] xl:w-[480px] bg-background border-l">
      <div className="flex-1 flex items-center justify-center p-6">
        <Alert variant={noId ? "default" : "destructive"}>
          {noId ? (
            <AlertCircle className="h-4 w-4" />
          ) : (
            <XCircle className="h-4 w-4" />
          )}
          <AlertDescription>
            {noId ? (
              "No order ID provided. Please select an order to view details."
            ) : (
              <>
                <strong>Order not found</strong>
                <br />
                {error instanceof Error
                  ? error.message
                  : "The requested order could not be loaded."}
              </>
            )}
          </AlertDescription>
        </Alert>
      </div>
    </div>
  );
}

